import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=7a8b79f2&scoped=true&"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetConfirm.vue?vue&type=style&index=0&id=7a8b79f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8b79f2",
  null
  
)

export default component.exports